<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="d-flex align-items-center p-3 my-3 text-dark-50 bg-lightblue rounded shadow-sm">
          <div class="lh-100">
            <h6 class="border-bottom border-gray pb-2 mb-0 lh-100">Template Lists</h6>
          </div>
          <div class="form-group ml-auto">
<!--            <label for="integrated_number" class="col-form-label">Integrated Number <span-->
<!--                class="text-danger">*</span></label>-->
            <select class="form-control" id="integrated_number" v-model="integrated_number"
                    @change="getOnLoadMessageLogs" required>
              <option v-for="(option, key) in phones" :value="option.whatsAppId" :key="key">{{ option.name }}
                (+91 {{ option.phonenumber }})
              </option>
            </select>
          </div>
        </div>
        <div class="table-responsive">
          <table class="table">
            <thead class="text-bold">
            <tr>
              <th scope="col">NAME</th>
              <th scope="col">CATEGORY</th>
              <th scope="col">LANGUAGE</th>
              <th scope="col">STATUS</th>
              <th scope="col">MESSAGE</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="row in tables" :key="row.id">
              <th scope="row">{{ row.name }}</th>
              <td>{{ row.category }}</td>
              <td>{{ row.language }}</td>
              <td>{{ row.status }}</td>
              <td><p v-for="com in row.components" :key="com.id"><strong>{{ com.type }} : </strong>{{ com.text }}</p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";

export default {
  data() {
    return {
      form: {
        template: 'hellow_world',
        campaign: 'campaign',
        referrel: 'referrel',
        source: 'source',
        fileUpload: null,
      },
      tables: [],
      phones: [],
      integrated_number: "105991995863083",
      token: "",
      show: true
    }
  },
  async created() {
    this.token = this.$route.params.waId
    var getWaId = await this.getNumberIntegrationList();
    this.phones = getWaId.data.message;
    var getTemp = await this.getTemplates();
    this.tables = getTemp.data.data.data;
  },
  methods: {
    onSubmit(event) {
      event.preventDefault()
      // alert(JSON.stringify(this.form))
      var form = new FormData();
      form.append('template', this.form.template);
      form.append('campaign', this.form.campaign);
      form.append('referrel', this.form.referrel);
      form.append('source', this.form.source);
      form.append('fileUpload', this.form.fileUpload);
      const NMPUSER = JSON.parse(localStorage.getItem('NMPUSER'))
      const config = {
        // 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': NMPUSER.token
        }
      }
      axios.post('http://localhost:3011/whatsApp/xlsx',
          form, // the data to post
          config).then(response => console.log(response));
      console.log(form);
    }, onFileChange(event) {
      this.form.fileUpload = event.target.files[0]
    },
    onReset(event) {
      event.preventDefault()
      // Reset our form values
      this.form.template = ''
      this.form.name = ''
      this.form.food = null
      this.form.checked = []
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    async getTemplates() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/message_templates';
      return await this.axiosRequest(templateURL, {
        waId: this.integrated_number
      });
    },
    async getNumberIntegrationList() {
      // const templateURL = 'https://graph.facebook.com/v16.0/100312339706932/message_templates?limit=3&access_token=EAAUJ4rpATrABAFJfj9AwJGKRzBX4l3VSNmfLZAlCcVChd8qGX8P6yv3djKZC8Kr9NEKhCagzqIbf8vTiuYt2xBPGjUr9prMuhOgYnvz2PDfcX5ioweo4RFwKOj884xG9beG0XmDPH1n1rmYd2zQJGfoHQQehlUj0gHxZCs1oNSZBEFQUos3qtqgOISZAthbLOC7PP1FRIawQmZC2ZCG3lzM7Xg7ZC41BTIsZD';
      const templateURL = '/whatsApp/number_integration_list';
      return await this.axiosRequest(templateURL, {
        waId: this.waId
      });
    },
    async getOnLoadMessageLogs() {
      var getTemp = await this.getTemplates();
      this.tables = getTemp.data.data.data;
    }
  }
}
</script>
<style>
@media (min-width: 1024px) {
  .about {
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
}
.bg-lightblue {
  background-color: lightblue;
}
/*td {*/
/*  white-space: normal !important;*/
/*  word-wrap: break-word;*/
/*}*/
/*table {*/
/*  table-layout: fixed;*/
/*}*/
</style>
